export let TRACKERIDS = [
  {
    partner: "tiktok",
    clientId: "jazz_tiktok_2m1i",
    clientSc: "TOQW2FTR",
    //Encrypted Value  (clientId:clientSc) => jazz_ttc:8N1UB27WOF2
    //amF6el90dGM6OE4xVUIyN1dPRjI=
  },
  {
    partner: "2m1i",
    clientId: "jazz_ttc",
    clientSc: "8N1UB27WOF2",
    //Encrypted Value  (clientId:clientSc) => jazz_ttc:8N1UB27WOF2
    //amF6el90dGM6OE4xVUIyN1dPRjI=
  },
  {
    partner: "mobipium",
    clientId: "jazz_mobipim",
    clientSc: "X05XX",
    //Encrypted Value  (clientId:clientSc) => jazz_mobipim:FF8UB27WOF2
    //amF6el9tb2JpcGltOkZGOFVCMjdXT0Yy
  },
  {
    partner: "2m3i",
    clientId: "jazz_2m3i",
    clientSc: "H81K96XOB5",
    //Encrypted Value  (clientId:clientSc) => jazz_2m3i:H81K96XOB5
    //amF6el8ybTNpOkg4MUs5NlhPQjU=
  },
  {
    partner: "2m4i",
    clientId: "jazz_2m4i",
    clientSc: "H8UB27L0D5",
    //Encrypted Value  (clientId:clientSc) => jazz_2m4i:H8UB27L0D5
    //amF6el8ybTRpOkg4VUIyN0wwRDU=
  },
  {
    partner: "2m5i",
    clientId: "jazz_2m5i",
    clientSc: "HRCB20MXZ",
    //Encrypted Value  (clientId:clientSc) => jazz_2m5i:HRCB20MXZ
    //amF6el8ybTVpOkhSQ0IyME1YWg==
  },

  {
    partner: "2m7i",
    clientId: "jazz_2m7i",
    clientSc: "H923KZQP21",
    //Encrypted Value  (clientId:clientSc) => jazz_2m7i:H923KZQP21
    //amF6el8ybTdpOkg5MjNLWlFQMjE=
  },
  {
    partner: "2m8i",
    clientId: "jazz_2m8i",
    clientSc: "H0ALAZZM9",
    //Encrypted Value  (clientId:clientSc) => jazz_2m8i:H0ALAZZM9
    //amF6el8ybThpOkgwQUxBWlpNOQ==
  },
  {
    partner: "noetic_google_ads",
    clientId: "noetic_google_ads",
    clientSc: "9KPWAAMAU",
  },
  {
    partner: "noetic",
    clientId: "noetic_479",
    clientSc: "6KGZYO7YH2",
    //Encrypted Value  (clientId:clientSc) => noetic_479:6KGZYO7YH2
    //bm9ldGljXzQ3OTo2S0daWU83WUgy
  },
  {
    partner: undefined,
    clientId: "noetic_479",
    clientSc: "6KGZYO7YH2",
    //Encrypted Value  (clientId:clientSc) => noetic_479:6KGZYO7YH2
    //bm9ldGljXzQ3OTo2S0daWU83WUgy
  },
  {
    partner: "noetic_jazz_ads",
    clientId: "noetic_jazz_ads",
    clientSc: "9KPEYQ99QI",
    //Encrypted Value  (clientId:clientSc) => noetic_479:6KGZYO7YH2
    //bm9ldGljXzQ3OTo2S0daWU83WUgy
  },

  {
    partner: "2m9i",
    clientId: "jazz_2m9i",
    clientSc: "HB0123SKA0",
    //Encrypted Value  (clientId:clientSc) => noetic_479:6KGZYO7YH2
    //bm9ldGljXzQ3OTo2S0daWU83WUgy
  },
  {
    partner: "2m18i",
    clientId: "samino_2022_jazz",
    clientSc: "9MK092AB",
    //Encrypted Value  (clientId:clientSc) => noetic_479:6KGZYO7YH2
    //bm9ldGljXzQ3OTo2S0daWU83WUgy
  },
  {
    // for ayaaz only

    partner: "2m12i",
    clientId: "jazz_2m12i",
    clientSc: "9OP1A2P0Q",
    //Encrypted Value  (clientId:clientSc) => noetic_479:6KGZYO7YH2
    //bm9ldGljXzQ3OTo2S0daWU83WUgy
  },
  {
    partner: "propellerads",
    clientId: "jazz_propellerads",
    clientSc: "P201124",
  },
  {
    partner: "goldengoose",
    clientId: "jazz_goldengoose",
    clientSc: "GG22JA",
    //Encrypted Value  (clientId:clientSc) => noetic_479:6KGZYO7YH2
    //bm9ldGljXzQ3OTo2S0daWU83WUgy
  },
  {
    partner: "Innomovil",
    clientId: "noetic_inomvl_gamenow",
    clientSc: "HM64M",
  },
  {
    partner: "mobikok",
    clientId: "jazz_2m5i",
    clientSc: "HRCB20MXZ",
  },

  {
    partner: "mobplus",
    clientId: "jazz_2m6i",
    clientSc: "HH950ZMNY",
    //Encrypted Value  (clientId:clientSc) => jazz_2m6i:HH950ZMNY
    //amF6el8ybTZpOkhIOTUwWk1OWQ==
  },
];
